import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67f6e40a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_task" }
const _hoisted_2 = { class: "list_search" }
const _hoisted_3 = { class: "search_header" }
const _hoisted_4 = {
  class: "flexWrap",
  style: {"width":"80%"}
}
const _hoisted_5 = { class: "header_nr flexAlign" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "项目编号：", -1))
const _hoisted_7 = { class: "header_nr flexAlign" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "项目名称：", -1))
const _hoisted_9 = { class: "header_nr flexAlign" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "表单类型：", -1))
const _hoisted_11 = {
  class: "header_nr flexAlign",
  style: {"margin-left":"20px"}
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_14 = {
  class: "flexEnd",
  style: {"padding":"20px"}
}
const _hoisted_15 = { class: "my-header" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "接单会签评审记录表", -1))

import { useRouter,useRoute } from 'vue-router';
	import { onMounted,ref,nextTick,computed } from 'vue';
	import { requestProjectAllList,requestBdList } from '@/api/xmApi';
	import {
        requestGetAllConfig
    } from '@/api/configApi.js';
	import AddTask from '@/components/AddTask.vue';
	import TaskDetails from '@/components/TaskDetails.vue'
	import sqpspage from '@/views/bd/sqps.vue';

	
export default /*#__PURE__*/_defineComponent({
  name: 'Allbd',
  setup(__props) {

	const showsqps= ref<boolean>(false)//添加任务
	const router = useRouter()
	const route = useRoute()
	const list = ref([])
	const loading = ref<boolean>(false)
	const addShowTask = ref<boolean>(false)//添加任务
	const addTask = ref<boolean>(false)
	const taskDetails = ref(false)//控制右侧弹窗
	const taskDetailsShow = ref(false)//控制右侧弹窗
	const form = ref({})

	const sxlxLists = ref<any[]>([])
	const projectlist = ref([])
	const taskid = ref(route.params.taskid)
	const yuqi =ref(route.params.yuqi);
	const pageIndex = ref<number>(1)
	const pageSize = ref<number>(10)
	const pages = ref({
		totalCount:0
	})

	const getallprojectList = () => {
		requestProjectAllList({}).then((res:any)=>{
			projectlist.value=res.datalist;
		})
	}
	const search = ref({
		status:0,
		sxlx:"",
		projectname:"",
		operatorname:"",
		startdate1:"",
		startdate2:"",
		type1:'',
		liketxt:"",
		code:''
	})
	
	const mx = ref({
		id:0,
		taskid:0
	})
	const getType = computed(()=>{
		return function(status:number){
			let b = {
				1:"primary",
				2:"danger",
				3:"warning",
				4:"success"
			}
			return b[status]
		}
	})
	const cancelDetails = () => {
		taskDetails.value = false
		getTaskList()
	}
	const cancelTask = (val:any) =>{
		addShowTask.value = false
		if(val){
			getTaskList()
		}
	}
	const searchList = () =>{
		pageIndex.value = 1
		getTaskList();
	}
	const details = (row:any) => {
		console.log(row.cell);
		console.log(row.cell.id);
		console.log(row.cell.taskid);
		mx.value.id=row.cell.id;
		mx.value.taskid=row.cell.taskid
		showsqps.value=true
		
	}
	//刷新列表
	const taskListsx = () => {
		getTaskList()
		taskDetails.value = false
	}
	//新建任务
	const createTask = () => {
		tasksx()
		addShowTask.value = true
	}
	const tasksx = () => {
		addTask.value = false
		nextTick(()=>{
			addTask.value = true
		})
	}
	onMounted(()=>{
		getallprojectList();
		getTaskList();
		getSxlx();
	})
	const getSxlx = () => {
		console.log("sxlx");
        requestGetAllConfig({
            type:"事项类型"
        }).then((res:any)=>{
            if(res.status === 1){
            	console.log(res.datalist);
                sxlxLists.value = res.datalist
            }
        })
    }
	const getTaskList = () => {
		loading.value = true
		requestBdList({
			pageIndex:pageIndex.value,
			pageSize:pageSize.value,
			code:search.value.code,
			projectname:search.value.projectname,
			type1:search.value.type1,
		}).then((res:any)=>{
			list.value = res.data
			pages.value.totalCount = res.totalCount
			loading.value = false
		})
	}
	const handleSizeChange = (val: number) =>{
		pageSize.value = val
		getTaskList();
	}
	const handleCurrentChange = (val: number) =>{
		pageIndex.value = val
		getTaskList();
	}
	const back = () =>{
		router.go(-1)
	}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.code,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.value.code) = $event)),
              style: {width:'100px'},
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (searchList()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_select, {
              size: "small",
              filterable: "",
              modelValue: search.value.projectname,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search.value.projectname) = $event)),
              placeholder: "请选择",
              style: {"width":"100px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectlist.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: `${item.code}-${item.projectname}`,
                    value: `${item.projectname}`,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.type1,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((search.value.type1) = $event)),
              style: {width:'100px'},
              onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (searchList()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_button, {
              plain: "",
              type: "primary",
              size: "small",
              icon: _ctx.Search,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (searchList()))
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["icon"])
          ])
        ])
      ])
    ]),
    _hoisted_13,
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      onCellClick: details,
      data: list.value,
      "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          width: "80",
          label: "序号",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.code",
          label: "项目编号",
          width: "200"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.projectname",
          label: "项目名称",
          width: "400"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.bdtype",
          label: "表单类型",
          width: "200"
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        currentPage: pageIndex.value,
        "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((pageIndex).value = $event)),
        "page-sizes": [10, 20, 30],
        "page-size": pageSize.value,
        "onUpdate:page-size": _cache[7] || (_cache[7] = ($event: any) => ((pageSize).value = $event)),
        layout: "total, sizes, prev, pager, next, jumper",
        total: pages.value.totalCount
      }, null, 8, ["currentPage", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      top: "5vh",
      modelValue: showsqps.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((showsqps).value = $event)),
      "show-close": false,
      "close-on-click-modal": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (showsqps.value=false)),
            style: {"float":"right"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (showsqps.value)
          ? (_openBlock(), _createBlock(sqpspage, {
              key: 0,
              sqpsidid: mx.value.id,
              taskid: mx.value.taskid,
              onCancelTask: _cache[9] || (_cache[9] = ($event: any) => (showsqps.value=false))
            }, null, 8, ["sqpsidid", "taskid"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})